const updateCardsHeights = (ref: HTMLDivElement) => {
  const splittedProposalTopLabels = ref.getElementsByClassName('splitted-proposal-top-label');
  const propositionTopCards = ref.getElementsByClassName('proposition-card-top-container');
  const propositionBottomCards = ref.getElementsByClassName('proposition-card-bottom-container');

  const allSplittedTopHeight: number[] = [];
  const allTopHeight: number[] = [];
  const allBottomHeight: number[] = [];
  for (let i = 0; i < propositionTopCards.length; i++) {
    allSplittedTopHeight.push(splittedProposalTopLabels?.[i]?.clientHeight);
    allTopHeight.push(propositionTopCards?.[i]?.clientHeight);
    allBottomHeight.push(propositionBottomCards?.[i]?.clientHeight);
  }

  const maxSPH = Math.max(...allSplittedTopHeight);
  const maxTopH = Math.max(...allTopHeight);
  const maxBottomH = Math.max(...allBottomHeight);

  if (maxSPH) {
    for (let i = 0; i < splittedProposalTopLabels.length; i += 1) {
      if (splittedProposalTopLabels[i].clientHeight < maxSPH)
        (splittedProposalTopLabels[i] as HTMLElement).style.height = `${maxSPH}px`;
    }
  }

  if (maxTopH) {
    for (let i = 0; i < propositionTopCards.length; i += 1) {
      if (propositionTopCards[i].clientHeight < maxTopH)
        (propositionTopCards[i] as HTMLElement).style.height = `${maxTopH}px`;
    }
  }

  if (maxBottomH) {
    for (let i = 0; i < propositionBottomCards.length; i += 1) {
      if (propositionBottomCards[i].clientHeight < maxBottomH)
        (propositionBottomCards[i] as HTMLElement).style.height = `${maxBottomH}px`;
    }
  }
};

export { updateCardsHeights };
